module.exports = __webpack_public_path__ + "img/vendor_logo7.ebb15f3d.png";